/** Drawn marks for the duel — font glyphs for ✓ ✗ ▲ ▼ differ too much between phones. */

export function Check({ draw = false }: { draw?: boolean }) {
  return (
    <svg className={draw ? "du-draw" : undefined} viewBox="0 0 24 24" aria-hidden="true">
      <path d="M5 12.8l4.4 4.4L19 7.6" pathLength={1} fill="none" stroke="currentColor" strokeWidth={3.2} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function Cross({ draw = false }: { draw?: boolean }) {
  return (
    <svg className={draw ? "du-draw" : undefined} viewBox="0 0 24 24" aria-hidden="true">
      <path d="M7 7l10 10M17 7L7 17" pathLength={1} fill="none" stroke="currentColor" strokeWidth={3.2} strokeLinecap="round" />
    </svg>
  );
}

export function Tri({ up }: { up: boolean }) {
  return (
    <svg viewBox="0 0 12 10" aria-hidden="true">
      <path
        d={up ? "M6 1.2L10.8 8.8H1.2Z" : "M6 8.8L1.2 1.2H10.8Z"}
        fill="currentColor"
        stroke="currentColor"
        strokeWidth={1.4}
        strokeLinejoin="round"
      />
    </svg>
  );
}
